import React from "react";
import SignUp from "../../components/SignUp";
// import { useAuth, } from "../../redux/pagesSlices/authSlice";

export default function Signup() {
  // useAuth();
  return (
    <div className="Login_page">
      <SignUp />
    </div>
  );
}
